"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDebounce;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
/**
 *  Use this hook when working with variables that you don't want to be constantly updated.
 * (e.g. sending the text that the user typed in the searchbox
 * to the backend continuously and searching the database)
 * @param {any} value Variable you want to debounce (e.g. text input)
 * @param {number} delay The amount of time (in milliseconds) you want to
 * delay updating (debounce) the variable "value" (e.g. 500)
 * @returns {any} the "value" variable
 * (it takes at least "delay" milliseconds from the last update for this variable to be updated)
 */
function useDebounce() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var _React$useState = _react.default.useState(value),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    debouncedValue = _React$useState2[0],
    setDebouncedValue = _React$useState2[1];
  _react.default.useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}